import { Box, Button, Modal, Tooltip, Typography } from '@mui/material';
import { Add, Edit, Delete, Help, ArrowBack, Close } from '@mui/icons-material';

const StandardWizard = ({
  title,
  disabled,
  variant = 'add',
  buttonLabel,
  onChange,
  required = false,
  children = null,
  step = 1,
  setStep = () => {},
  ActionComponent = null,
  showSteps = false,
  totalSteps = 3,
  showWizard = false,
  setWizard = () => {},
}) => {
  const Icon = () => {
    switch (variant) {
      case 'add':
        return <Add />;
      case 'edit':
        return <Edit />;
      case 'delete':
        return <Delete />;
      case 'help':
        return <Help />;
      default:
        return null;
    }
  };

  const colorMap = {
    add: 'primary',
    edit: 'secondary',
    delete: 'error',
    help: 'info',
  };

  const useColor = colorMap[variant] || 'default';

  if (!showWizard) {
    return (
      <Button
        variant="outlined"
        endIcon={<Icon />}
        disabled={disabled}
        onClick={() => setWizard(true)}
        color={useColor}
      >
        <>
          {required && <span style={{ color: 'red' }}>*</span>}
          {buttonLabel || 'Open Wizard'}
        </>
      </Button>
    );
  } else {
    return (
      <Modal
        open={showWizard}
        onClose={() => setWizard(false)}
        aria-labelledby="wizard-modal-title"
        aria-describedby="wizard-modal-description"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box>
          <Box
            sx={{
              width: {
                xs: '90vw',
                md: '60vw',
                lg: '50vw',
                xl: '40vw',
              },
              bgcolor: 'background.paper',
              boxShadow: 24,
              border: 2,
              borderColor: 'grey.500',
              borderRadius: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
              borderBottom={1}
              borderColor="grey.400"
              flexDirection={'row'}
              bgcolor="#E7F6D8"
            >
              {step !== 1 && (
                <Box
                  sx={{
                    cursor: 'pointer',
                    marginRight: 2,
                    borderRight: 1,
                    borderColor: 'grey.400',
                    padding: 1,
                  }}
                  onClick={() => setStep((prev) => Math.max(prev - 1, 0))}
                >
                  <Tooltip title="Go Back a Step" arrow>
                    <ArrowBack color="primary" />
                  </Tooltip>
                </Box>
              )}
              <Typography
                id="wizard-modal-title"
                variant="h6"
                component="h2"
                sx={{ flexGrow: 1, textAlign: 'center', padding: 1 }}
                color="#333"
              >
                <>
                  {title || 'Wizard'}
                  {showSteps && (
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{ marginLeft: 1, borderLeft: 1, paddingLeft: 1 }}
                    >
                      Step {step} of {totalSteps}
                    </Typography>
                  )}
                </>
              </Typography>

              <Box
                sx={{
                  cursor: 'pointer',
                  marginLeft: 2,
                  borderLeft: 1,
                  borderColor: 'grey.400',
                  padding: 1,
                }}
              >
                <Tooltip title="Exit" arrow onClick={() => setWizard(false)}>
                  <Close color="error" />
                </Tooltip>
              </Box>
            </Box>
            <Box
              minHeight={{
                xs: '40vh',
                sm: '40vh',
                md: '40vh',
              }}
              maxHeight={'70vh'}
              overflow="auto"
            >
              {children}
            </Box>
            {ActionComponent && (
              <Box
                sx={{
                  display: 'flex',
                  flex: 1,
                }}
              >
                <ActionComponent />
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    );
  }
};

export default StandardWizard;
